import {
  BUTTON_SUBMISSION,
  CLICK_HERE_LINK,
  EMBED_REGISTRATION,
  PREFERRED_PRICING,
  SUBMISSION,
  PACKAGE_SELECTION,
  ACCOUNT
} from "../constants";
import { setAnalytics } from "../thd-analytics-utils";

export const embeddedRegistration = () => {
  const trackEvent = (event) => {
    digitalData.event = digitalData.event || [];
    digitalData.event.push(event);
  };

  const embeddedRegistrationEvents = {
    onPage: () => {
      digitalData.page = {
        pageInfo: {
          pageName: `account>${PREFERRED_PRICING}>registration`,
          pageType: "maml: pricing",
        },
        category: {
          primaryCategory: ACCOUNT,
          subCategory1: `account>${PREFERRED_PRICING}`,
          subCategory2: `account>${PREFERRED_PRICING}>registration`,
        },
      };
      setAnalytics(digitalData);
    },

    clickGetStarted: () => {
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: "my account settings",
        },
        myAccount: {
          settings: `${PREFERRED_PRICING}: ${EMBED_REGISTRATION}: lets get started button`,
        },
      };
      trackEvent(DDOEvent);
    },

    clickCancel: () => {
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: "my account settings",
        },
        myAccount: {
          settings: `${PREFERRED_PRICING}: ${EMBED_REGISTRATION}: cancel button`,
        },
      };
      trackEvent(DDOEvent);
    },

    clickCategory: ({ output }) => {
      const category = output?.category;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: "my account settings",
        },
        myAccount: {
          settings: `${PREFERRED_PRICING}: ${EMBED_REGISTRATION}: ${SUBMISSION}: ${category}`,
        },
      };
      trackEvent(DDOEvent);
    },

    clickBusinessType: ({ output }) => {
      const businessType = output?.businessType;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: "my account settings",
        },
        myAccount: {
          settings: `${PREFERRED_PRICING}: ${EMBED_REGISTRATION}: business id: ${businessType}`,
        },
      };
      trackEvent(DDOEvent);
    },

    clickPackage: () => {
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: "my account settings",
        },
        myAccount: {
          settings: `${PREFERRED_PRICING}: ${EMBED_REGISTRATION}: ${PACKAGE_SELECTION}: ${CLICK_HERE_LINK}`,
        },
      };
      trackEvent(DDOEvent);
    },

    clickBusinessRegistration: ({ output}) => {
      const id = output?.id;
      const name = output?.name;
      const templates = output?.templates;
      const campaign = output?.campaign;
      const component = output?.component;
      const element = output?.element;
      
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: "content module click",
        },
        pageInfo: {
          pageType: "maml: pricing",
        },  
        content:{
          widgets: [
            {
              action: 'biz id and info',
              id: id, 
              name: name, 
              templates: templates, 
              campaign: campaign, 
              component: component, 
              element: element
            }
          ],
        }
      };
      trackEvent(DDOEvent);
    },
  };

  window.LIFE_CYCLE_EVENT_BUS.on(
    "embeddedRegistration.page-view",
    embeddedRegistrationEvents.onPage
  );
  window.LIFE_CYCLE_EVENT_BUS.on(
    "embeddedRegistration.click-getstarted",
    embeddedRegistrationEvents.clickGetStarted
  );
  window.LIFE_CYCLE_EVENT_BUS.on(
    "embeddedRegistration.click-cancel",
    embeddedRegistrationEvents.clickCancel
  );
  window.LIFE_CYCLE_EVENT_BUS.on(
    "embeddedRegistration.click-category",
    embeddedRegistrationEvents.clickCategory
  );
  window.LIFE_CYCLE_EVENT_BUS.on(
    "embeddedRegistration.click-businessregistration",
    embeddedRegistrationEvents.clickBusinessRegistration
  );
  window.LIFE_CYCLE_EVENT_BUS.on(
    "embeddedRegistration.click-business-type",
    embeddedRegistrationEvents.clickBusinessType
  );
  window.LIFE_CYCLE_EVENT_BUS.on(
    "embeddedRegistration.click-package",
    embeddedRegistrationEvents.clickPackage
  );
};
